import React, { Component } from "react";
import { Form, Select, Modal, Icon } from "antd";
import {Input, message} from "@ezviz/ezd";
import dclog from '../../common/utils/dclog';
import "./index.less";


const FormItem = Form.Item;


message.config({
  top: "40%"
});

class WrappedProbationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 0,
    };
  }
  hanelEmailChange(e) {
    const value = e.target.value;
    this.setState({
      email: value
    });
  }
  hanelEnterpriseChange(e) {
    const value = e.target.value;
    this.setState({
      enterprise: value
    });
  }
  componentWillMount() {      //必须在这里声明，所以 ref 回调可以引用它
      this.props.onRef(this)
  }
  addWork = (values) => {
    const { appKey, simpleDescription = "售前咨询" } = this.props;
    const workListType = "H-3";

    let params = {};

    params.appKey = appKey;
    params.simpleDescription = simpleDescription;
    params.contactWay = values.contactWay;
    params.questionDescription = values.questionDescription;

    let extraOptionsAi = [];

    extraOptionsAi.push({
      key: "email",
      value: values.email,
      label: "邮箱"
    });
    extraOptionsAi.push({
      key: "enterprise",
      value: values.enterprise,
      label: "企业名"
    });
    extraOptionsAi.push({
      key: "name",
      value: values.name,
      label: "姓名"
    });
    Object.assign(params, { extraOptionsAi: JSON.stringify(extraOptionsAi) }, { workListType: workListType });

    const succes = data => {
      if (data.retcode === 0) {
        this.setState({
          step: 1,
        });
        this.props.onChange()
        message.destroy();
      } else if (data.retcode === -1){
        message.error("操作频繁，请稍后再试");
      } else {
        message.error("提交失败，请重试");
      }
    };
    const error = error => {
      console.log("创建工单失败e", error);
      // message.error("提交失败，请重试");
      message.error(error);
    };
    values["appKey"] = appKey;
    console.log("values", values);
    fetch("/work/createByAdvisory", {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(params)
    })
      .then(response => response.json())
      .then((data) => {
        succes(data);
      })
      .catch((err) => {
        console.log(err);
        error(err)
      })
  }
  handleSubmit = e => {
    // e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let that = this;
        that.addWork(values);
      }
    });
    dclog({
      systemName: 'open_web_btn_action',
      bn: 18,
      action: 0,
      un: true,
      extra: `&page=${window.location.pathname}&text=ContactUs`
    })
  };
  ok = () => {
    this.setState({
      step: 0,
    })
    if (this.props.onOK) {
      this.props.onOK()
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { step } = this.state;
    return (
      <div className="contact-us">
        {step === 0 &&
          <div className={`common-contact-us-form ${this.props.theme}`} style={{padding: 0}}>
            <div className="contact-us-form-sub-title">{this.props.subTitle}</div>
            <Form className="work-form">
              <FormItem
              label="姓名"
              >
                {getFieldDecorator("name", {
                  rules: [{ max: 20, message: "最多可输入20个字符" }]
                })(
                    <Input placeholder="请输入" autoCapitalize={false} autoComplete={false} />
                )}
              </FormItem>
              <FormItem
              label="公司名称">
                {getFieldDecorator("enterprise", {
                  rules: [
                    { required: true, message: "请填写公司名称" },
                    { max: 20, message: "最多可输入20个字符" }
                  ]
                })(
                    <Input placeholder="请输入" autoCapitalize={false} autoComplete={false} />
                )}
              </FormItem>
              <FormItem
              label="邮箱">
                {getFieldDecorator("email", {
                  rules: [
                    { max: 30, message: "最多可输入30个字符" },
                    { pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: "邮箱格式不正确" }
                  ]
                })(
                    <Input id="key" placeholder="请输入" autoCapitalize={false} autoComplete={false} />
                )}
              </FormItem>
              <FormItem
              label="电话">
                {getFieldDecorator("contactWay", {
                  rules: [
                    { required: true, message: "请输入电话号码" },
                    { max: 20, message: "最多可输入20个字符" },
                    { pattern: /^[0123456789-]+$/, message: "电话号码格式不正确" }
                  ]
                })(
                      <Input
                        placeholder="请输入"
                        autoCapitalize={false} autoComplete={false}
                      />
                )}
              </FormItem>
              <FormItem
              label="您的产品及需求简介">
                {getFieldDecorator("questionDescription", {
                  rules: [
                    { required: true, message: "请输入产品及需求简介" },
                    { max: 255, message: "最多可输入255个字符" }
                  ]
                })(
                      <Input placeholder="请输入" autoSize={{ minRows: 1, maxRows: 3 }} autoCapitalize={false} autoComplete={false} />
                )}
              </FormItem>
            </Form>
          </div>
        }
        {step === 1 &&
          <div className={`submit-success ${this.props.theme}`}>
            <div className="success-img">
              <img src="https://resource.eziot.com/group1/M00/00/00/CtwQE171lIGAKpDsAAAfG1DXt-I688.png" />
            </div>
            <div className="success-title">感谢留言</div>
            <div className="success-sub-title">我们会尽快与您联系</div>
            <div className="submit-btn-container">
              <button className="submit-btn" onClick={() => this.ok()} style={{cursor:"pointer"}}>好的</button>
            </div>
          </div>
        }
      </div>
    );
  }
}

const ContactUsForm = Form.create()(WrappedProbationForm);

export default ContactUsForm;
